import { computed } from 'vue';
import { app } from '@ibgroup-tws-webapps/ratio.ui';

export function useConditionals() {
  // Force-enable on localhost so devs don't need the AB flag toggled in their
  // session to see the Conditional category locally.
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  const isConditionalsEnabled = computed(() => isLocalhost || !!app.abFeatures?.hasFeature('SHOW_PR_HUB_CONDITIONALS'));

  return { isConditionalsEnabled };
}
